import { render, staticRenderFns } from "./HomeFr.vue?vue&type=template&id=65418f8a&scoped=true&"
import script from "./HomeFr.vue?vue&type=script&lang=js&"
export * from "./HomeFr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65418f8a",
  null
  
)

export default component.exports